<template>
  <div class="card card-shadow p-2 mb-2">
    <div class="columns pl-2 pr-2 pt-1 pb-0">
      <div class="column is-3 ml-2">
        <div class="is-size-7 has-text-grey-light has-text-weight-normal">Site name</div>
        <div class="has-text-black has-text-weight-bold">{{ siteData.name }}</div>
      </div>
      <div class="column">
        <div class="columns">
          <div class="column">
            <div v-if="siteData.tasks === null" style="height: 48px"
                 class="is-flex is-align-items-center dashed-border-small ml-0 mr-0 mt-auto mb-auto">
              <h4 class="is-size-6 ml-auto mr-auto has-text-grey-light has-text-weight-light">No blurring tasks</h4>
            </div>
            <div v-else style="height: 48px" class="is-flex mt-auto mb-auto">
              <div class="clickable-info has-text-centered is-flex ml-1" style="height: 48px; width: 80px"
                   :style="statusStyle()" @click="showError">
                <div class="is-size-7 mt-auto mb-auto ml-auto mr-auto has-text-white">{{ siteData.tasks.status }}</div>
              </div>
              <div class="clickable-info ml-2 is-flex pt-2 pl-4" style="flex-grow: 1">
                <div class="m-0" style="flex: 1">
                  <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px;">
                    {{ siteData.tasks.status === 'CREATED' ? 'CREATED TASKS' : 'QUEUED' }}
                  </div>
                  <div class="has-text-black has-text-weight-bold" style="line-height: 1">
                    {{ siteData.tasks.status === 'CREATED' ? siteData.tasks.created : siteData.tasks.queued }}
                  </div>
                </div>
                <div class="m-0" style="flex: 1" v-if="siteData.tasks.status !== 'CREATED'">
                  <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">IN PROGRESS</div>
                  <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                      siteData.tasks.inProgress
                    }}
                  </div>
                </div>
                <div style="flex: 0.5" class="is-flex" v-if="siteData.tasks.status !== 'CREATED'">
                  <hr class="mt-0 mb-1 ml-auto mr-auto has-background-grey-lighter" style="width: 1px; height: 30px">
                </div>
                <div class="m-0" style="flex: 1" v-if="siteData.tasks.status !== 'CREATED'">
                  <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">FAILED</div>
                  <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                      siteData.tasks.failed
                    }}
                  </div>
                </div>
                <div class="m-0" style="flex: 1" v-if="siteData.tasks.status !== 'CREATED'">
                  <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px">COMPLETED</div>
                  <div class="has-text-black has-text-weight-bold" style="line-height: 1">{{
                      siteData.tasks.completed
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-flex is-align-items-center is-justify-content-flex-end" style="max-width: 110px">
            <b-tooltip v-if="refreshing"
                       label="Please Wait..." :delay="1000" type="is-dark" position="is-left">
              <div class="my-loader"></div>
            </b-tooltip>
            <b-tooltip v-else-if="siteData.tasks === null && !refreshing" label="Create Tasks" :delay="1000" position="is-left"
                       type="is-dark">
              <b-icon icon="plus-circle" class="clickable" style="color: rgba(30,43,87,0.4)"
                      size="is-medium" @click.native="onCreateTasksClick"></b-icon>
            </b-tooltip>
            <template v-else-if="siteData.tasks && siteData.tasks.status === 'CREATED' && !refreshing">
              <b-tooltip label="Restart process" :delay="1000" type="is-dark" position="is-left" class="mr-1">
                <b-icon
                    icon="close-circle"
                    class="clickable" size="is-medium" style="color: red"
                    @click.native="onResetClick"></b-icon>
              </b-tooltip>
              <b-tooltip label="Run Tasks" :delay="1000" type="is-dark" position="is-left">
                <b-icon
                    icon="play-circle"
                    class="clickable" size="is-medium" style="color: rgba(30,43,87,0.4)"
                    @click.native="onRunTasksClick"></b-icon>
              </b-tooltip>
            </template>
            <b-tooltip v-else-if="siteData.tasks && siteData.tasks.status === 'RUNNING' && !refreshing"
                       label="Please Wait..." :delay="1000" type="is-dark" position="is-left">
              <b-icon
                  icon="progress-clock"
                  class="clickable" size="is-medium"></b-icon>
              <b-progress size="is-small" :value="progressValue"></b-progress>
            </b-tooltip>
            <template v-else-if="siteData.tasks && siteData.tasks.status === 'COMPLETED' && !refreshing">
              <b-tooltip label="Restart process" :delay="1000" type="is-dark" position="is-left" class="mr-1">
                <b-icon
                    icon="close-circle"
                    class="clickable" size="is-medium" style="color: red"
                    @click.native="onResetClick"></b-icon>
              </b-tooltip>
              <b-tooltip label="Download Videos" :delay="1000" type="is-dark" position="is-left">
                <b-icon
                    icon="download-circle"
                    class="clickable" size="is-medium" style="color: #18AA7E"
                    @click.native="onDownloadClick"></b-icon>
              </b-tooltip>
            </template>
            <b-tooltip v-else-if="siteData.tasks && siteData.tasks.status === 'FAILED' && !refreshing"
                       label="Restart process" :delay="1000" type="is-dark" position="is-left">
              <b-icon
                  icon="close-circle"
                  class="clickable" size="is-medium" style="color: red"
                  @click.native="onResetClick"></b-icon>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "blurring-data-card",
  props: {
    siteData: {
      type: Object
    },
    refreshing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      progressValue: 40
    }
  },
  methods: {
    setProgress(progress) {
      this.progressValue = progress
    },
    showError() {
      if (this.siteData.tasks && this.siteData.tasks.errors && this.siteData.tasks.errors.length > 0) {
        this.$emit('onShowError', this.siteData.tasks.errors)
      }
    },
    statusStyle() {
      if (this.siteData.tasks && this.siteData.tasks.status) {
        if (this.siteData.tasks.status === 'CREATED') {
          return {background: '#8C84FF'}
        } else if (this.siteData.tasks.status === 'RUNNING') {
          return {background: '#D8BA13'}
        } else if (this.siteData.tasks.status === 'COMPLETED') {
          return {background: '#1CAB80'}
        } else if (this.siteData.tasks.status === 'FAILED') {
          if (this.siteData.tasks.errors && this.siteData.tasks.errors.length > 0) {
            return {background: '#e02c2c', cursor: 'pointer'}
          } else {
            return {background: '#e02c2c'}
          }
        }
      }
      return {background: '#000000'}
    },
    onCreateTasksClick() {
      this.$emit('onCreateTasksClick', this.siteData)
    },
    onRunTasksClick() {
      this.$emit('onRunTasksClick', this.siteData)
    },
    onDownloadClick() {
      this.$emit('onDownloadClick', this.siteData)
    },
    onResetClick() {
      this.$emit('onResetClick', this.siteData)
    }
  }
}
</script>

<style scoped lang="scss">
.card-shadow {
  box-shadow: 0 0.125em 0.125em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  background-color: white;
  border-radius: 0.35rem;
}

.dashed-border-small {
  padding: 8px 8px;
  border-style: dashed;
  border-radius: 8px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.1);
}

.clickable-info {
  background: #f4f4f4;
  border-radius: 0.3rem;
}

.clickable:hover {
  cursor: pointer;
}

.my-loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #1cab80;
  border-bottom: 4px solid #1cab80;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
